// Entry point for the build script in your package.json

import "@hotwired/turbo-rails"
import 'lib/turbo-extensions'
import 'lib/cable'
import 'lib/turbo-stream-animations'
import 'lib/choices-select'

import 'controllers'
import '../components'

Turbo.config.drive.progressBarDelay = 150

if (window?.MinuteDock?.debug) {
  [ 'click', 'before-visit', 'visit', 'before-cache', 'before-render', 'render', 'load',
    'morph', 'before-morph-element', 'before-morph-attribute', 'morph-element',
    'submit-start', 'submit-end',
    'before-frame-render', 'frame-render', 'frame-load', 'frame-missing',
    'before-stream-render',
    'before-fetch-request', 'before-fetch-response', 'before-prefetch', 'fetch-request-error'
  ].forEach(eventName => document.addEventListener(`turbo:${eventName}`, event => {
    console.log(`turbo:${eventName}`, event)
  }))
}

